import { render, staticRenderFns } from "./AttemptTextDiff.vue?vue&type=template&id=24adb51a"
import script from "./AttemptTextDiff.vue?vue&type=script&lang=js"
export * from "./AttemptTextDiff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports